// src/components/AthletesCSV.js
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Button } from "@mui/material";

function AthletesCSV() {
    const [rows, setRows] = useState([]);
    const [lastFile, setLastFile] = useState(null);

    // 🔄 Charger automatiquement le dernier fichier enrichi au montage
    useEffect(() => {
        fetch("http://localhost:4000/get-json/athletes_enriched.json")
            .then((res) => {
                if (!res.ok) throw new Error("Pas de fichier enrichi disponible");
                return res.json();
            })
            .then((data) => {
                setRows(data);
                setLastFile("athletes_enriched.json");
                console.log("✅ Athlètes enrichis chargés automatiquement");
            })
            .catch((err) => {
                console.warn("⚠️ Aucun fichier enrichi trouvé:", err.message);
            });
    }, []);

    // 📥 Import CSV (aperçu)
    const handleCSVUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        fetch("/upload-csv", {
            method: "POST",
            body: formData,
        })
            .then((res) => {
                if (!res.ok) throw new Error(`Erreur serveur: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                alert(
                    `✅ Athlètes enregistrés dans /data : ${data.file} (${data.count} lignes)`
                );
                setRows(data.preview || []);
                setLastFile(data.file);
            })
            .catch((err) => {
                console.error("Erreur:", err);
                alert("❌ Une erreur est survenue lors de l'import du CSV");
            });
    };

    // 🔍 Charger la liste complète
    const handleLoadFull = () => {
        if (!lastFile) {
            alert("⚠️ Aucun fichier sauvegardé à charger");
            return;
        }

        fetch(`http://localhost:4000/get-json/${lastFile}`)
            .then((res) => {
                if (!res.ok) throw new Error(`Erreur serveur: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                setRows(data);
                alert(`✅ Liste complète chargée (${data.length} athlètes)`);
            })
            .catch((err) => {
                console.error("Erreur:", err);
                alert("❌ Impossible de charger la liste complète");
            });
    };

    // 🔁 Mettre à jour avec un nouveau CSV
    const handleUpdateCSV = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        fetch("http://localhost:4000/update-athletes", {
            method: "POST",
            body: formData,
        })
            .then((res) => {
                if (!res.ok) throw new Error(`Erreur serveur: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                alert(
                    `✅ Mise à jour : ${data.added} nouveaux athlètes ajoutés (total ${data.total})`
                );
                fetch(`http://localhost:4000/get-json/${data.file}`)
                    .then((res) => res.json())
                    .then((fullData) => setRows(fullData));
            })
            .catch((err) => {
                console.error("Erreur:", err);
                alert("❌ Impossible de mettre à jour les athlètes");
            });
    };

    const columns = [
        { field: "gender", headerName: "Sexe", width: 100 },
        { field: "noP", headerName: "No-P.", width: 100 },
        { field: "name", headerName: "Nom", width: 200 },
        { field: "year", headerName: "Année", width: 100 },
        { field: "category", headerName: "Catégorie", width: 120 },
        { field: "club", headerName: "Club", width: 200 },
        { field: "ar", headerName: "AR", width: 100 },
        { field: "ir", headerName: "IR", width: 100 },
        { field: "points", headerName: "Points", width: 100 },
        {
            field: "dernierResultat",
            headerName: "Dernier résultat",
            width: 400,
            renderCell: (params) => {
                const res = params.row?.results;
                if (Array.isArray(res) && res.length > 0) {
                    const last = res[res.length - 1];
                    return `${last.date} ${last.event} (${last.discipline}) → ${last.time} / ${last.penaltyFinal} pts`;
                }
                return "—";
            },
        },
    ];

    return (
        <Box sx={{ height: 700, width: "100%", padding: 2 }}>
            <Typography variant="h5" gutterBottom>
                Liste des athlètes SVAL (CSV)
            </Typography>

            <Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
                <Button variant="contained" component="label">
                    Importer un fichier CSV
                    <input type="file" accept=".csv" hidden onChange={handleCSVUpload} />
                </Button>

                {lastFile && (
                    <Button variant="outlined" onClick={handleLoadFull}>
                        Charger la liste complète
                    </Button>
                )}

                <Button variant="contained" component="label" color="secondary">
                    Mettre à jour avec un nouveau CSV
                    <input type="file" accept=".csv" hidden onChange={handleUpdateCSV} />
                </Button>
            </Box>

            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={20}
                rowsPerPageOptions={[20, 50, 100]}
                checkboxSelection
                disableSelectionOnClick
                getRowId={(row) => row.noP}
            />
        </Box>
    );
}

export default AthletesCSV;
